import { useState, useEffect } from "react";

const DevResolution = () => {
  const [w, setW] = useState();
  const [h, setH] = useState();

  function checkScreenSize() {
    setW(window.innerWidth);
    setH(window.innerHeight);
  }

  useEffect(() => {
    checkScreenSize(); // run once on mount

    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  return (
    <div className="page-404">
      <div>
        <h2>
          Current window width and height: {w} × {h}
        </h2>
      </div>
    </div>
  );
};

export default DevResolution;
